import FetchProxy from "./FetchProxy";

export default class Login {

    formSelector = ".js-login-form";
    buttonSelector = ".js-login-btn";

    restUrl= null;
    restQuery= {};
    formUrl= null;
    urlOnLogin= "";

    jsFormErrorsSelector = ".model-form .js-form-errors";
    debug=true;

    /**
     * Id cuando se guarda el formulario
     */
    idSaved=null;
    /**
     * The record is created new
     */
    _isNew= false;

    $_form=null;

    /**
     * Proxy para hacer llamdas a fetch
     * @type {null}
     */
    fetchProxy=null;

    constructor() {
        this.fetchProxy=new FetchProxy();
    }

    get$Form() {
        if (this.$_form==null) {
            this.$_form=$(this.formSelector);
            this.log("form=" + this.formSelector);
        }
        return this.$_form;
    }

    async validateAndLogin() {
        let me=this;
        let $form = this.get$Form();
        let request = $form.serializeArray();
        let namesFormMultiple={};

        let restUrl=me.restUrl;
        if (restUrl==null) {
            restUrl = $(this.formSelector).attr("action");
        }
        // Para los elementos múltiples crea un array
        $(me.buttonSelector).prop("disabled",true);
        $form.find(".js-login-error").hide().find("span").html("");

        try {
            //restUrl='https://api.spotify.com/v1/artists/0OdUWJ0sBjDrqHygGUXeCFcdsds';
            let response = await this.fetchUrlPostUrlEncoded(restUrl, this.getAsPureArray(request));
            let data = await response.json();
            if (data.errorCode==0) {
                me.onLoginSuccess();
            } else {
                throw {message:"Error", errorMessages:data.errorMessages};
            }
        } catch(e) {
            console.log(e);
            $(me.buttonSelector).prop("disabled",false);
            me.onLoginError(e.errorMessages);
        }
        /*
                let xhr = $.ajax(restUrl,{
                    method: "post",
                    data: request,
                    dataType: "json",
                    success: ( data ) => {
                        this.log(data);
                        if (data.errorCode==0) {
                            me.onLoginSuccess();
                        } else {
                            $(me.buttonSelector).prop("disabled",false);
                            me.onLoginError(data.errorMessages);
                        }
                    },
                    error: ( data ) =>{
                        this.log(data.responseText);
                        me.onLoginError();
                    }
                });
                */
    }

    async fetchUrlPostUrlEncoded(url, postdataobj, params) {
        let result = await this.fetchProxy.fetchUrlPostUrlEncoded(url, postdataobj, params);
        return result;
    }


    // Logea en consola el mensaje. Sólo útil en depuración
    log(message) {
        if (this.debug) {
            console.log(message);
        }
    }
    t(s) {
        return s
    }
    onLoginSuccess() {
        this.log("logging ok");
        if (this.urlOnLogin!="") {
            window.location.href=this.urlOnLogin;
        } else {
            this.log("logging ok without urlOnLogin");
        }
    }
    showMessageWithModal(msg) {
        //swal(msg);
        alert(msg);
    }

    /**
     * Se ha producido un error al hacer el login. Se muestra el mensaje de error
     * @param messages
     */
    onLoginError(messages) {
        let $form = this.get$Form();
        let message=this.t("Error al enviar los datos");
        try {
            message = messages[0]["errorMessage"];
        } catch(e) {

        }
        $form.find(".js-login-error").show().find("span").html(message);
    }
    /**
     * in is [ {name:1,value:4} ] and out is {"name":1}
     * @param nameValuePair
     * @returns {{}|*}
     */
    getAsPureArray(nameValuePair) {
        let result={};
        $.each(nameValuePair, function(index, nameValue) {
            result[nameValue.name]=nameValue.value;
        });
        return result;
    }

    /**
     * Inicializa los eventos del formulario para que caundo se pulse en "guardar" se activen los eventos necesarios
     */
    initEvents() {
        $(this.formSelector).on('submit', (event) => {
            event.preventDefault();
            this.validateAndLogin();
            return false;
        });
    }
}